<template>
  <div class="r-pagination" v-if="pagination">
    <span class="demonstration">共 {{ pagination.total }} 条，每页显示 {{ pagination.pageSize }} 条</span>
    <el-pagination
      class="mt-4"
      ref="page"
      background
      v-model:current-page="pagination.pageIndex"
      :page-size="pagination.pageSize"
      :page-sizes="pagination.pageSizes || [5, 10, 20, 50, 100, 200, 500]"
      layout="sizes, prev, pager, next, jumper"
      :total="pagination.total*1"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'RPagination',
  props: {
    pagination: Object,
  },
  data() {
    return {
      canSavePage: -1 // 是否可以保存分页信息 -1：不保存；0：下次之后可以保存；1：可以保存
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler(val) {
        // 这是针对有tab的页面，在切换tab后pagination变更没有通知到组件内部的容错机制
        if (this.canSavePage === -1) {
          return
        }
        if (this.canSavePage === 0) {
          this.canSavePage = 1
          return
        }
        // if (this.canSavePage === 1) {
        //   localStorage.setItem('curUrlPageIndex', val.pageIndex)
        //   localStorage.setItem('curUrlPageSize', val.pageSize)
        // }
      }
    }
  },
  mounted() {
    // let curUrlPageSize = Number(localStorage.getItem('curUrlPageSize'))
    // let curUrlPageIndex = Number(localStorage.getItem('curUrlPageIndex'))
    // if (curUrlPageIndex || curUrlPageSize) {
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.canSavePage = 0
    //       this.handleCurrentChange(curUrlPageIndex || 1)
    //       this.$nextTick(() => {
    //         this.$refs.page.internalCurrentPage = curUrlPageIndex || 1 // 强制更新，解决页码不自动更新的问题
    //       })
    //     }, 500);
    //   })
    // }
  },
  methods: {
    handleCurrentChange(val) {
      // localStorage.setItem('curUrlPageIndex', val)
      // let curUrlPageSize = Number(localStorage.getItem('curUrlPageSize')) || this.pagination.pageSize
      this.$emit('current-change', val, this.pagination.pageSize)
    },
    handleSizeChange(val) {
      // localStorage.removeItem('curUrlPageIndex')
      // localStorage.setItem('curUrlPageSize', val)
      this.$emit('current-change', 1, val)
    },
  },
}
</script>

<style lang="less" scoped>
.r-pagination {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  .el-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
<style lang="less">
.r-pagination {
  border: none;
  font-size: @font-tiny;
  .el-pagination.is-background .el-pager li {
    background-color: transparent;
    cursor: pointer;
    font-weight: normal;
    padding: 0;
    min-width: 24px;
    &:hover {
      color: @theme-color;
    }
    &.active {
      background-color: @theme-color;
      border: 1px solid @theme-color;
      border-radius: 3px;
      &:hover {
        color: @base-color;
      }
    }
    &:focus{
      outline: none !important;
    }
  }
  .el-pagination__sizes {
    .el-input__inner {
      height: 26px !important;
    }
  }
}
</style>
